import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextRenin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />
Blood pressure is regulated by a complex neurohumoral system including the renin-angiotensin-aldosterone system, natriuretic peptides, endothelial pathways, the sympathetic nervous system, and the immune system.<br /> <br /> 

Hypertension is a major risk factor for heart disease, stroke, kidney failure, and eye problems (Medline). Environmental factors also contribute to hypertension. In addition to race and age, activity level, alcohol consumption, and salt intake influence blood pressure. 
Other disorders, such as obesity, diabetes, and obstructive sleep apnea also increase the risk of developing hypertension.

The renin-angiotensin-aldosterone system (RAAS), or renin-angiotensin-system (RAS) is a regulator of blood pressure and cardiovascular function. 
Dysregulated RAAS is implicated in high blood pressure, cardiovascular and kidney conditions, and medications targeting RAAS can improve these conditions.<br /> <br /> 

In summary, the renin-angiotensin-aldosterone system (RAAS) is a critical regulator of blood pressure (blood volume & electrolyte balance) as well as vascular tone & resistance. 
Normally, renin is secreted if blood pressure is too low thus activating angiotensin II to increase blood pressure and vascular resistance.
Abnormal activation of RAAS leads to chronic hypertension, cardiac failure, and kidney conditions.<br /> <br /> 

Because these genes play an integral role in normal blood pressure control, researchers suspect that variations in them might impair blood pressure control and contribute to hypertension.<br /> <br /> 
Drug targets are angiotensin-converting enzyme (ACE) inhibitors and angiotensin II receptor blockers. 
Drugs inhibiting the RAAS pathway such as ACE inhibitors and ARBs are effective treatments for hypertension and cardiac failure.<br /> <br /> 
For the treatment of hypertension, an important drug class is beta-blockers. It is recommended to examine the variants within CYP2D6 for the optimal dosing and avoiding the USE of this drug class <br /><br />

Vascular Endothelium plays a fundamental role in the cardiovascular system, forming an interface between blood and adjacent tissues 
by regulating the vascular tone through the synthesis of nitric oxide, prostaglandins and other relaxing factors. <br /><br />
In hypertension endothelial dysfunction may be involved in the initiation and development of vascular inflammation, vascular remodeling, and atherosclerosis and is independently associated with increased cardiovascular risk. 
Potential innovative therapeutic strategies targeting the endothelium with the aim to improve vascular function and remodeling.

<br /> <br />


<Typography component="span" variant="h5" sx={{fontWeight: '600'}}>Associated Genes: </Typography>
<br /><br />
 'DCP1', 'ACE', 'AGT', 'AGTR1', 'ADD1', 'NPPA', 'ADRB2', 'SCNN1A', 'GNB3', 'NOS3', 'VDR', 'AT1R', 'AT2R', 'ACE-2', 'AT1R', 'AT2R', 'ACE-2'
 <br /><br /> 


<br /><br /> 
 
</Typography>

</div>
)
}